import { Navigate, Outlet, useOutletContext } from "react-router";
import Forbidden from "src/pages/Forbidden";

const ProtectedRoute = ({ hasPermission = (context) => true, children }) => {
    const context = useOutletContext();    
    if (context.userInfo && context.userInfo.loaded === false)
        context.getUserPermissions();
    
    if (!context.userInfo || hasPermission(context) === false) {        
        // access denied
        return <Forbidden loading={!context.userInfo.loaded} />;
    }

    return children ? children : <Outlet context={context} />;
};

export default ProtectedRoute